import { useLocation } from "react-router-dom";
import Header from "../../Molecules/Header/Header";
import Footer from "../../Molecules/Footer/Footer";
import "./SearchBar.css";

const IframeComponent = () => {
  const location = useLocation();
  let { slug, id } = location.state || {};

  // Fallback if page was refreshed
  // if (!slug || !id) {
  //   const stored = JSON.parse(sessionStorage.getItem("mf-data"));
  //   slug = stored?.slug;
  //   id = stored?.id;
  // }

  const apiKey = "351b03c24a79d2f40796037e0d8c2c49";
  const callbackUrl = "https://www.wisefunds.in/login"

  if (!slug || !id) {
    return <p style={{ color: "red" }}>Invalid or missing fund data.</p>;
  }

  const url = `https://redvisionassets.com/iframes/performance/single-fund/${slug}?pcode=${id}&redirecturl=${callbackUrl}&apikey=${apiKey}`;

  return (
    <>
      <Header />
      <div className="search-detail-main">
        <iframe
          src={url}
          title="Embedded Page"
          style={{ width: "100%", height: "100vh" }}
        />
      </div>
      <Footer />
    </>
  );
};

export default IframeComponent;
